import { Button, Grid } from '@mui/material';
import { IBannerAction } from 'app/models/Global/Global';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const BannerActions = ({
  action,
  justifyContent,
}: {
  action: IBannerAction;
  justifyContent?: 'flex-start' | 'flex-end';
}) => {
  return (
    <Grid container justifyContent={justifyContent}>
      {action === IBannerAction.refreshPage && (
        <Grid item>
          <RefreshButton />
        </Grid>
      )}
    </Grid>
  );
};

const RefreshButton = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const onClick = () => {
    history(0);
  };
  return (
    <Button disableElevation color="primary" variant="contained" onClick={onClick}>
      {t('Refresh')}
    </Button>
  );
};
